// LSA Transaction Types based on backend structure

import { LSACategory, LSACategoryInput } from './types';

export enum LSATransactionStatus {
  Incomplete = "Incomplete",
  PendingApproval = "PendingApproval",
  Completed = "Completed",
  Cancelled = "Cancelled",
  Denied = "Denied",
}

export enum CurrencyTypes {
  CAD = 'CAD',
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  BRL = 'BRL'
}

export interface Amount {
  currency: CurrencyTypes;
  value: number;
}

export interface AdminUser {
  createdBy?: string;
  updatedBy?: string;
}

export enum RecordStatus {
  ACTIVE = 'active',
  DELETED = 'deleted',
  SUSPENDED = 'suspended'
}

export interface LSATransaction {
  id: string;
  currency: CurrencyTypes;
  userId: string;
  partnerId: string;
  groupId: string;
  categoryId: string;
  costAmount: number; // Total amount spent
  receiptDate: Date;
  brandName: string;
  coveredAmount: Amount; // Amount covered by LSA
  maxCoveragePercentage: number;
  receiptS3URL: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  partnerReceipt: string;
  paymentId?: string;
  status?: LSATransactionStatus;
  manuallyUpdated?: boolean;
  lockingDate?: Date;
  adminUser?: AdminUser;
  recordStatus?: RecordStatus;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface LSATransactionConnection {
  items: LSATransaction[];
  nextToken?: string;
  totalCount: number;
}

export interface TransactionFilter {
  status?: LSATransactionStatus;
  dateRange?: {
    startDate: Date;
    endDate: Date;
  };
  categoryId?: string;
  memberId?: string;
  searchTerm?: string;
}

export interface ExportOptions {
  scope: 'current' | 'all';
  columns: {
    memberName: boolean;
    brandName: boolean;
    category: boolean;
    totalAmount: boolean;
    reimbursedAmount: boolean;
    processingFee: boolean;
    receiptLink: boolean;
    dateSubmitted: boolean;
    status: boolean;
  };
}

export interface LSAGroup {
  id: string;
  name: string;
  partnerId: string;
  categories: LSACategory[];
  yearlySpendingLimit: number;
  currency: CurrencyTypes;
  prorated: boolean;
  startDate?: string;
  resetDate?: string;
  runOffPeriod?: number;
  status: 'Active' | 'Deleted' | 'Paused';
  membersCount: number;
  coveragePercentage: number;
  createdAt?: string;
  updatedAt?: string;
}


export interface LSAGroupUpdateInput {
  name?: string;
  yearlySpendingLimit?: number;
  currency?: CurrencyTypes;
  prorated?: boolean;
  startDate?: string;
  resetDate?: string;
  runOffPeriod?: number;
  coveragePercentage?: number;
  categories?: LSACategoryInput[];
}

export interface PaginationInfo {
  page: number;
  limit: number;
  totalCount: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface TransactionTableData {
  transactions: LSATransaction[];
  pagination: PaginationInfo;
  filters: TransactionFilter;
  isLoading: boolean;
  error?: string;
}
